import { addPermissionsToRoute } from '@qsrsoft/myq-core';
import { multiClientMenuFilters } from '../mtEnterprises';
const routes = {
  name: 'Sales',
  icon: 'mdi-chart-line',
  path: '/reports/sales',
  ...addPermissionsToRoute(['mtSales']),
  menuFilters: multiClientMenuFilters,

  children: [
    {
      path: '/reports/sales/salesLedger',
      name: 'Sales Ledger',
      meta: {
        id: 'reports-mtSalesLedger',
      },
      component: () => import('./SalesLedger.vue'),
    },
    {
      path: '/reports/sales/salesPointOfOrder',
      name: 'Sales - Point Of Order',
      meta: {
        id: 'reports-mtSalesPointOfOrder',
      },
      component: () => import('./SalesPointOfOrder.vue'),
    },
    {
      path: '/reports/sales/salesDetail',
      name: 'Sales Detail',
      meta: { id: 'reports-mtSalesDetail' },
      component: () => import('./SalesDetail.vue'),
    },
    {
      path: '/reports/sales/qboDailySales',
      name: 'QBO Daily Sales',
      meta: { id: 'reports-mtQboDailySales' },
      component: () => import('./QboDailySales.vue'),
    },
    {
      path: '/reports/sales/closingHour',
      name: 'Closing Hour',
      meta: {
        id: 'reports-mtSalesClosingHour',
      },
      component: () => import('./ClosingHour.vue'),
    },
  ],
};

export default routes;
